import React, { Fragment, useState} from 'react';
import { useSnackbar } from 'notistack';
import { Grid, Paper } from "@material-ui/core";
import MomentUtils from '@date-io/moment';
import { MuiPickersUtilsProvider, KeyboardDatePicker } from '@material-ui/pickers';
import moment from 'moment';
import { backendDateFormat, fieldDateFormat } from '../../../constants';
import { withRouter } from 'react-router';
import { checkApiStatus } from '../../utils_v2';
import { ExportMenu, PageLoader } from '../../shared_elements';
import { globalGetService } from '../../../globalServices';
import { checkPermission } from '../../../console_management/utils_v2';
import { trackActivity } from '../../../utils/mixpanel';
const AssetLogReport = ({ownerList}) => {
    const { enqueueSnackbar, closeSnackbar } = useSnackbar();
    const [isLoading, setLoading] = useState(false);
    const [error, setError] = useState({});
    const [start_date, setStart_date] = useState('');
    const [end_date, setEnd_date] = useState('');

    const exportAssetLogReport = (extension) => {
        let validationInputs = {};
        validationInputs = {
            ...validationInputs,
            start_date: start_date ? '' : 'Please enter From Date',
            end_date: end_date ? '' : 'Please enter To Date'
        }
        if(start_date == 'Invalid date'){
            validationInputs = {
                ...validationInputs,
                start_date: 'Please enter valid From Date'
            }
        }
        if(end_date == 'Invalid date'){
            validationInputs = {
                ...validationInputs,
                end_date: 'Please enter valid To Date'
            }
        }
        if (start_date !== 'Invalid date' && end_date !== 'Invalid date') {
            if (moment(end_date).isBefore(moment(start_date))) {
                validationInputs = {
                    ...validationInputs,
                    end_date: 'To Date Cannot be lesser than From Date'
                }
            }
        }
        if (Object.keys(validationInputs).every((k) => { return validationInputs[k] === '' })) {
            setLoading(true)
            globalGetService(`/console/export-asset-log-report/?start_date=${moment(start_date).format(backendDateFormat)}&end_date=${moment(end_date).format(backendDateFormat)}`)
            .then(response => {
                setLoading(false);
                if(checkApiStatus(response)){
                    enqueueSnackbar(response.data.message, { variant: 'success', anchorOrigin: { vertical: 'top', horizontal: 'right' } });
                    setEnd_date(null); setStart_date(null);
                    trackActivity('Console Management', { page_title: 'Custom Report', item_type: 'Export', event_type:'Asset Log Report Exported', event_desc: 'Asset Log Report Exported Successfully' })
                }else{
                    enqueueSnackbar(response.data.message, { variant: 'error', anchorOrigin: { vertical: 'top', horizontal: 'right' } });
                }
            });
        }else{
            setError(validationInputs)
        }
    }
    const onResetErrorKey = (keyParam) => {
        setError({...error, [keyParam]:''})
    }
    return(
        <Paper square>
            <Grid container spacing={0} alignItems='center'>
                <Grid item md={12}>
                    <div className='custom-rpt-card'>
                        <div className='rpt-card-header'>
                            <Grid container spacing={1}>
                                <Grid item md={9}>
                                    <h4>Asset Information Log</h4>
                                    <p>Details of Changes Made to Asset or Major Assemblies in SPARTA. Includes Changes Made to Lease Status or On-Wing Status.</p>
                                </Grid>
                                <Grid item md={3}>
                                {checkPermission('reports','custom_reports','EXP') ? <ExportMenu 
                                        exportReportFn={(file) => exportAssetLogReport(file.extension)}
                                        files={[{title:'EXCEL', extension:'xlsx'}]}
                                    /> : null}
                                </Grid>
                            </Grid>
                        </div>
                        <div className='rpt-card-body'>
                            <Grid container spacing={1}>
                                <Grid item md={6}>
                                    <MuiPickersUtilsProvider utils={MomentUtils}>
                                        <KeyboardDatePicker
                                            required
                                            margin="normal"
                                            id="start_date"
                                            format={fieldDateFormat}
                                            label="From Date"
                                            fullWidth
                                            InputLabelProps={{ shrink: true }}
                                            disableFuture
                                            value={start_date ? start_date : null}
                                            error={error.start_date ? true : false}
                                            helperText={error.start_date ? error.start_date : ''}
                                            onChange={(data) => { setStart_date(('start_date', moment(data).format(backendDateFormat))); onResetErrorKey('start_date') }}
                                            inputVariant='outlined'
                                        />
                                    </MuiPickersUtilsProvider>
                                </Grid>
                                <Grid item md={6}>
                                    <MuiPickersUtilsProvider utils={MomentUtils}>
                                        <KeyboardDatePicker
                                            required
                                            margin="normal"
                                            id="end_date"
                                            format={fieldDateFormat}
                                            label="To Date"
                                            fullWidth
                                            InputLabelProps={{ shrink: true }}
                                            disabled={!start_date ?  true : false}
                                            value={end_date ? end_date : null}
                                            error={error.end_date ? true : false}
                                            helperText={error.end_date ? error.end_date : ''}
                                            onChange={(data) => { setEnd_date(('end_date', moment(data).format(backendDateFormat))); onResetErrorKey('end_date') }}
                                            inputVariant='outlined'
                                        />
                                    </MuiPickersUtilsProvider>
                                </Grid>

                            </Grid>
                        </div>
                    </div>
                </Grid>
            </Grid>
            { isLoading ? <PageLoader/>:null}
        </Paper>
    )
}
export default withRouter(AssetLogReport);